/**
 * Pure helpers for TipTap composer link edits.
 */

import type { Editor } from '@tiptap/react';
import { isSafeHttpUrl } from './slackKeyboardShortcuts';

export function applyComposerLinkUrl(editor: Editor, next: string | null): boolean {
  if (next === null) return false;
  const trimmed = next.trim();
  if (!trimmed) {
    editor.chain().focus().extendMarkRange('link').unsetLink().run();
    return true;
  }
  if (!isSafeHttpUrl(trimmed)) return false;
  editor.chain().focus().extendMarkRange('link').setLink({ href: trimmed }).run();
  return true;
}
